import { render, staticRenderFns } from "./EventModalCategories.vue?vue&type=template&id=0cac7421&scoped=true"
import script from "./EventModalCategories.vue?vue&type=script&lang=js"
export * from "./EventModalCategories.vue?vue&type=script&lang=js"
import style0 from "./EventModalCategories.vue?vue&type=style&index=0&id=0cac7421&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cac7421",
  null
  
)

export default component.exports